import { useMemo } from 'react';
import { TomTomApiResult } from '../../../types/TomTom/TomTomApiResult';
import './DestinationTile.scss';
import SvgIcon from '../../../common/SvgIcon/SvgIcon';
import Text from '../../../common/Text/Text';

const DestinationTile = ({
  destination,
  onClick,
}: {
  destination: TomTomApiResult;
  onClick: (v: TomTomApiResult) => void;
}) => {
  const name = useMemo(() => {
    if (destination.type === 'POI') return destination.poi?.name;
    return destination.address.freeformAddress.split(',')[0];
  }, [destination.address.freeformAddress, destination.poi?.name, destination.type]);

  const address = useMemo(() => {
    if (destination.type === 'POI') return destination.address.freeformAddress;
    return destination.address.freeformAddress.split(',').splice(1).join(',');
  }, [destination.address.freeformAddress, destination.type]);

  const icon = useMemo(() => {
    if (destination.poi?.classifications?.find(({ code }) => code === 'AIRPORT')) return 'Plane';

    return 'LocationDot';
  }, [destination.poi?.classifications]);

  return (
    <button className="destination-tile" onClick={() => onClick(destination)}>
      <SvgIcon iconName={icon} width={16} height={16} fill="var(--primary)" />
      <div className="address">
        <Text type="callout">{name}</Text>
        <Text type="body" size="small">
          {address}
        </Text>
      </div>
    </button>
  );
};

export default DestinationTile;
